import React from 'react';
/** ************* COMPONENTS  ******************** */
import Card from 'components/Cards/Card';
import { Box,SimpleGrid } from '@chakra-ui/react';
import BackButton from 'components/Button/BackButton';
import RefreshIcon from 'components/icons/RefreshIcon';
import TransactionDetails from './components/TransactionDetails';

// react router dom
import { useParams } from 'react-router-dom';
import { useGetTransactionByIdQuery } from 'reducers/transaction.service';

const TransactionDetailsHeaders = () => {
    let { id } = useParams();
    // const { data, refetch,isLoading,isError } = useGetCompanyQueryQuery(id);

    const { refetch } = useGetTransactionByIdQuery(id);

    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <SimpleGrid
                mb="20px"
                columns={{ sm: 1, md: 1 }}
                spacing={{ base: '20px', xl: '20px' }}
            >
                <Card>
                    <div className="page-head-box space-between-box">
                        <div className="start-box">
                            <BackButton/>
                            <p>Transaction Details</p>
                        </div>
                        <div>
                            <RefreshIcon refetch={refetch} />
                        </div>
                    </div>
                    <div>
                        <TransactionDetails />
                    </div>
                </Card>
            </SimpleGrid>
        </Box>
    );
};

export default TransactionDetailsHeaders;
